import { SxProps } from '@mui/material';

export const DpInformativeFrameSX: SxProps = {
	padding: {
		xs: '20px 20px 20px 20px',
	},
};
